<template>
    <div class="foldable-text" id="head">
        <div :class="{show: btn_flag, hidden: !btn_flag}" v-html="text" style="padding: 10px 20px;font-size: 15px;"></div>
        <div class="d-flex justify-center">
          <v-btn icon @click="changeState">
            <v-icon>{{btn}}</v-icon>
          </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: "FoldableText",

    props: {
        text: {
            type: String
        },
        top: {
            type: Number
        },
    },

    data: function() {
      return {
        btn: "mdi-chevron-down",
        btn_flag: false,
        backPosition: 0,
      }
    },

    mounted: function() {
    },

    methods: {
      changeState: function() {
        if(this.btn_flag) {
          this.btn = "mdi-chevron-down";
          document.documentElement.scrollTop = this.backPosition;
        }
        else {
          this.btn = "mdi-chevron-up";
          this.backPosition = window.pageYOffset;
        }
        this.btn_flag = !this.btn_flag;

      }
    }
}
</script>

<style scoped>
.hidden {
  position: relative;
  overflow: hidden;
  height: 80px; /*隠した状態の高さ*/
}
.hidden::before {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px; /*グラデーションで隠す高さ*/
  background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,0.9) 50%, rgba(255,255,255,0.9) 50%, #fff 100%);
  background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.9) 50%, rgba(255,255,255,0.9) 50%, #fff 100%);
  content: "";
}
</style>